import mapboxgl from 'mapbox-gl'

import storeImg from '~/assets/new_gofind/markerPin.svg'
import pinCustomColor from './PinCustom'

export function createStoreMarker(map, store, onClick, setStoreHover, pin) {
  const { name, cnpj, coordinates } = store
  const wrapper = document.createElement('div')
  const image = document.createElement('img')
  const svg = document.createElement('section')
  const title = document.createElement('span')
  const shadow = document.createElement('div')
  const pulse = document.createElement('div')

  const pinCustom =
    pin && pin?.pointMarker === 'default'
      ? storeImg
      : pin?.pointMarker === 'personalization'
      ? pin?.imageIconSvg
      : storeImg

  const pinCustomSvg = pinCustomColor(pin?.colorAction, pin?.typePointMarker)

  wrapper.classList.add('gofind-map-store')
  wrapper.id = `map-store-${cnpj}`
  svg.innerHTML = `${pinCustomSvg}`
  image.src = pinCustom
  image.alt = name
  title.classList.add('map-title')
  title.innerText = store?.name?.split('&#')[0]?.trim()
  shadow.classList.add('store-shadow')
  pulse.classList.add('store-pulse')

  wrapper.appendChild(pin?.pointMarker === 'simple' ? svg : image)
  wrapper.appendChild(title)
  wrapper.appendChild(pulse)
  wrapper.appendChild(shadow)

  const marker = new mapboxgl.Marker(wrapper)
    .setLngLat(coordinates?.latlon?.split(',')?.reverse())
    .addTo(map)

  wrapper.addEventListener('click', () => onClick(store))
  wrapper.addEventListener('mouseover', setStoreHover)

  return marker
}
